import Vue from 'vue';
import VueResource from 'vue-resource';
import constants from '@/constants/Url.constants';
import router from '@/router';
import store from '@/store';

Vue.use(VueResource);

Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
  request.headers.set('Accept', 'application/json');
  next((response) => {
    if (response.status === 401) {
      store.commit('logout');
      router.push({ path: 'login' });
    }
  });
});

/* eslint-disable prefer-template */
export default {
  zendeskInfo(ticket) {
    return Vue.http.get(`${constants.API_URL}/zendesk/${ticket}`);
  },
  ticketInfo(code, category, complaintType) {
    return Vue.http.get(`${constants.API_URL}/tickets/${code}?category=${category}&complaint_type=${complaintType}`);
  },
  post(complaint) {
    return Vue.http.post(`${constants.API_URL}/complaints`, {
      complaint },
    );
  },
  get(id) {
    return Vue.http.get(`${constants.API_URL}/complaints/${id}`);
  },
  status(id) {
    return Vue.http.get(`${constants.API_URL}/status/${id}`);
  },
  status_submit(id, data) {
    return Vue.http.put(`${constants.API_URL}/status/${id}`, data);
  },
  status_bank(id, data) {
    return Vue.http.post(`${constants.API_URL}/status/${id}/bank`, data);
  },
  status_paypal_account(id, paypalAccount) {
    return Vue.http.post(`${constants.API_URL}/status/${id}/paypal_account`, paypalAccount);
  },
  update(id, complaint) {
    return Vue.http.put(`${constants.API_URL}/complaints/${id}`, {
      complaint },
    );
  },
  forceUpdate(id, complaint) {
    return Vue.http.put(`${constants.API_URL}/complaints/${id}`, {
      complaint, force: true },
    );
  },
  complaints(page, pending, text, sort, ecommerce) {
    let query = `${constants.API_URL}/complaints?pending=${pending}&ecommerce=${ecommerce}`;
    const age = sort ? 'asc' : 'desc';
    if (page !== undefined) {
      query += `&page=${page}`;
    }
    if (text !== '') {
      query += `&text=${text}`;
    }
    query += `&age=${age}`;
    return Vue.http.get(query);
  },
  all_complaints(offset, limit, filters) {
    const filter = Object.keys(filters).map(key => `${key}=${encodeURIComponent(filters[key].filter)}`).join('&');
    return Vue.http.get(`${constants.API_URL}/complaints?offset=${offset}&limit=${limit}&${filter}&external=true`);
  },
  activities(id, ecommerce) {
    if (id === undefined) {
      return Vue.http.get(`${constants.API_URL}/activity?ecommerce=${ecommerce}`);
    }
    return Vue.http.get(`${constants.API_URL}/complaints/${id}/activity?ecommerce=${ecommerce}`);
  },
  comments(id) {
    return Vue.http.get(`${constants.API_URL}/complaints/${id}/comments`);
  },
  upload_file(id, data) {
    return Vue.http.post(`${constants.API_URL}/complaints/${id}/additional_info`, data);
  },
  append_file(id, data) {
    return Vue.http.put(`${constants.API_URL}/complaints/${id}/additional_info/${data.request_id}`, data);
  },
  request_info(id, request) {
    return Vue.http.post(`${constants.API_URL}/complaints/${id}/additional_info`, {
      request },
    );
  },
  post_comment(id, content) {
    return Vue.http.post(`${constants.API_URL}/complaints/${id}/comments`, {
      content },
    );
  },
  register(activity) {
    return Vue.http.post(`${constants.API_URL}/activity`, {
      activity },
    );
  },
  get_operators() {
    return Vue.http.get(`${constants.API_URL}/bus_operators`);
  },
  // eslint-disable-next-line
  create_operator(bus_operator) {
    return Vue.http.post(`${constants.API_URL}/bus_operators`, {
      bus_operator },
    );
  },
  // eslint-disable-next-line
  update_operator(bus_operator, id) {
    return Vue.http.put(`${constants.API_URL}/bus_operators/${id}`, {
      bus_operator },
    );
  },
  get_users(page, search) {
    let query = `${constants.API_URL}/users?&page=${page}`;
    if (search.text !== '') { query += `&search=${search.text}`; }
    if (search.active !== '') { query += `&active=${search.active}`; }
    if (search.role !== '') { query += `&role_number=${search.role}`; }
    return Vue.http.get(query);
  },
  get_categories(page, ecommerce = false) {
    let query = `${constants.API_URL}/categories`;
    if (page) {
      query += `?page=${page}`;
    } else {
      query += '?paginate=false';
    }
    query += `&ecommerce=${ecommerce}`;
    return Vue.http.get(query);
  },
  // eslint-disable-next-line
  create_user(user) {
    Object.assign(user, { role_number: user.role });
    return Vue.http.post(`${constants.API_URL}/users`, {
      user },
    );
  },
  // eslint-disable-next-line
  update_user(user, id) {
    Object.assign(user, { role_number: user.role });
    return Vue.http.put(`${constants.API_URL}/users/${id}`, {
      user },
    );
  },
  update_category(category, id) {
    return Vue.http.put(`${constants.API_URL}/categories/${id}`, { category });
  },
  delete_user(id) {
    return Vue.http.delete(`${constants.API_URL}/users/${id}`);
  },
  recover_password(id) {
    return Vue.http.get(`${constants.API_URL}/users/${id}/recover_password`);
  },
  shift_active(id) {
    return Vue.http.get(`${constants.API_URL}/users/${id}/shift_active`);
  },
  confirm_email(token) {
    return Vue.http.get(`${constants.API_URL}/users/confirm_email?uct=${token}`);
  },
  save_password(params) {
    return Vue.http.put(`${constants.API_URL}/users/save_password`, {
      ...params },
    );
  },
  err() {
    return Vue.http.get(`${constants.API_URL}/users/err`);
  },
  finance(page, text, resolved) {
    let query = `${constants.API_URL}/finance/complaints?resolved=${resolved}&page=${page || 1}`;
    if (text !== '') {
      query += `&text=${text}`;
    }
    return Vue.http.get(query);
  },
  uploadBice(data) {
    return Vue.http.post(`${constants.API_URL}/finance/import`, data);
  },
  downloadBice(options) {
    let query = `${constants.API_URL}/finance/download?from=${options.from}&to=${options.to}&interval=${options.interval}`;
    if (options.busOperator !== '') {
      query += `&bus_operator=${options.busOperator}`;
    }
    if (options.category) {
      query += `&category=${options.category}`;
    }
    if (options.excludedOperators) {
      query += `&excluded=${options.excludedOperators}`;
    }
    return Vue.http.get(query);
  },
  downloadAll() {
    return Vue.http.get(`${constants.API_URL}/finance/export`);
  },
  downloadDiscount(from, to) {
    return Vue.http.get(`${constants.API_URL}/finance/discounts?from=${from}&to=${to}`);
  },
  refundPaypal(options) {
    return Vue.http.post(`${constants.API_URL}/finance/refund_paypal`, { ...options });
  },
  getTotal(options) {
    let query = `${constants.API_URL}/finance/total?from=${options.from}&to=${options.to}&type=${options.action}&interval=${options.interval}`;
    if (options.busOperator !== '') {
      query += `&bus_operator=${options.busOperator}`;
    }
    if (options.category) {
      query += `&category=${options.category}`;
    }
    if (options.excludedOperators) {
      query += `&excluded=${options.excludedOperators}`;
    }
    return Vue.http.get(query);
  },
  removeAttachment(id, attachment) {
    return Vue.http.delete(`${constants.API_URL}/complaints/${id}/additional_info/${attachment}`);
  },
  exportComplaints() {
    return Vue.http.get(`${constants.API_URL}/complaints/download`);
  },
  changeCouponState(params) {
    return Vue.http.put(`${constants.API_URL}/ibilbidea/coupon_state`, params);
  },
  updateRefundMethod(id, refundMethod) {
    const params = { complaint: { refund_method: refundMethod.code, bank_account: { email: refundMethod.email } } };
    return Vue.http.put(`${constants.API_URL}/complaints/${id}/refund_method`, params);
  },
  reloadAppToFalse(params) {
    return Vue.http.put(`${constants.API_URL}/users/reload_app_to_false`, params);
  },
  reloadAppStatus() {
    return Vue.http.get(`${constants.API_URL}/users/reload_app_status/?id=${store.state.id}`);
  },
  getSignedLink(id, infoId) {
    return Vue.http.get(`${constants.API_URL}/complaints/${id}/additional_info/${infoId}/signed_link`);
  },
};



// WEBPACK FOOTER //
// ./src/services/apiService.js